import { BACKEND_URL, API } from './api';

/**
 * Korrigiert Datei-URLs für Production und R2
 * R2-URLs (https://...) werden direkt verwendet (OHNE API-Prefix!)
 * Lokale URLs (/uploads/) werden zu /api/uploads/ korrigiert
 */
export const correctFileUrl = (path) => {
  if (!path) return '';
  
  // R2-URLs direkt zurückgeben (OHNE jegliche Modifikation!)
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }
  
  // Relative Pfade mit API-Basis kombinieren
  if (path.startsWith('/uploads/')) {
    return `${API}${path}`;
  }
  
  if (path.startsWith('/api/')) {
    return `${BACKEND_URL}${path}`;
  }
  
  // Andere relative Pfade
  if (path.startsWith('/')) {
    return `${API}${path}`;
  }
  
  return path;
};

/**
 * Baut die vollständige Datei-URL
 * Für R2-URLs: direkt verwenden (OHNE API-Prefix!)
 * Für lokale Pfade: API-Basis + Pfad
 */
export const getFullFileUrl = (filePath) => {
  if (!filePath) return '';
  
  // R2-URLs (https://...) direkt zurückgeben - NICHT modifizieren!
  if (filePath.startsWith('http://') || filePath.startsWith('https://')) {
    return filePath;
  }
  
  // Lokale Pfade brauchen das API-Prefix
  if (filePath.startsWith('/api/')) {
    return `${BACKEND_URL}${filePath}`;
  }
  
  if (filePath.startsWith('/uploads/')) {
    return `${API}${filePath}`;
  }
  
  if (filePath.startsWith('/')) {
    return `${API}${filePath}`;
  }
  
  return filePath;
};

// Legacy alias for backward compatibility
export const buildFileUrl = getFullFileUrl;
